import { Link } from 'react-router-dom';

/**
 * Inline error rendering for the "user is out of credits" case in chat-based
 * arches. Surfaces a clickable Buy Credits link via react-router so we don't
 * lose SPA state with a hard reload.
 *
 * Customer Support has its own variant that adds a "create a support ticket"
 * link alongside this one — see SupportHomePage. Other arches that just need
 * the standard buy-credits prompt should use this component.
 */
export function InsufficientCreditsMessage() {
  return (
    <span>
      Your credit balance is too low for this action.{' '}
      <Link
        to="/credits"
        className="underline font-medium text-amber-700 dark:text-amber-300 hover:text-amber-900 dark:hover:text-amber-100"
      >
        Buy more credits
      </Link>{' '}
      to continue using Fias AI.
    </span>
  );
}
